import React from 'react';
import { TableView } from '../TableView';
import { createTableColumns } from './tableConfig';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { ProposalTableActions } from '../../../types';

interface Props extends ProposalTableActions<Proposal> {
  loading?: boolean;
  tableData: Proposal[];
}

export const BaseTable = ({ tableData, loading, ...actions }: Props) => {
  const columns = createTableColumns({ tableData, ...actions });

  return (
    <TableView<Proposal>
      loading={loading}
      columns={columns}
      minHeight="33.5rem"
      tableData={tableData}
      noData="No data about proposals"
      loadingText="Proposals loading..."
    />
  );
};
